<!-- Revised on 2025/05/13 by mnavarro -->
<template>
  <router-link class="nav-link" :to="to">
    <div class="text-center bg-white shadow icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center me-2">
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text ms-1">
      {{ text }}
    </span>
  </router-link>
</template>

<script>

  export default {
    name: "SidenavItem",
    props: {
      to: {
        type: [Object, String],
        required: true,
      },
      text: {
        type: String,
        required: true,
      },
    }
  };
  
</script>